<template>
  <!-- Quick Add Tag Dialog -->
  <v-dialog
    max-width="600px"
    v-model="addTagDialog">
    <AddTag
      @close="addTagDialog = false"
      @newTag="onNewTagAdded" />
  </v-dialog>

  <div
    style="width: 100%"
    :class="dense ? 'py-2' : 'mb-4 pa-3'"
    ref="tagtitle">
    <div class="tag-main-bar">
      <v-tabs
        v-if="toggled == true"
        style="display: flex; align-items: center"
        id="tag-slider-carousel-container"
        show-arrows>
        <v-chip
          :density="dense ? 'compact' : 'default'"
          class="mr-2 custom-chip"
          style="user-select: none"
          size="large"
          @click="
            toggleTagFilter(tag.uid);
            emit('select', tag);
          "
          :color="filterByTag.includes(tag.uid) ? 'primary' : ''"
          :class="filterByTag.includes(tag.uid) ? 'active-custom-tag' : ''"
          v-for="tag in filteredTags">
          <v-icon
            style="opacity: 0.7"
            v-if="tag.icon"
            size="x-small"
            class="mr-2">
            {{ tag.icon }}
          </v-icon>
          {{ tag.name }}
        </v-chip>
      </v-tabs>
      <div
        v-else
        class="tag-carousel-replacement">
        <p
          style="font-size: 20px; width: 100px"
          class="fadeInRight">
          All tags
        </p>
      </div>
      <v-card-title
        style="padding-left: 0px; padding-right: 0px; user-select: none"
        :class="
          toggled != true ? 'tag-expand-button-active' : 'tag-expand-button'
        "
        class="tag-expand-button subtleshadow"
        id="tag-expand-button"
        v-if="!editMode && !dense"
        @click="toggled = !toggled">
        <div
          class="tag-hide-icon"
          :class="toggled != true ? 'tag-hide-icon-active' : 'tag-hide-icon'"
          id="turn">
          <v-icon
            v-if="toggled == true"
            dark
            style="opacity: 1">
            mdi-expand-all
          </v-icon>
          <v-icon
            v-else
            dark
            style="opacity: 1">
            mdi-collapse-all
          </v-icon>
        </div>
        <!-- <v-divider
          class="mb-3"
          style="margin-bottom: 0px !important" /> -->
      </v-card-title>
    </div>

    <div
      style="display: flex; flex-wrap: wrap; align-content: start"
      class="tag-container"
      :class="toggled == true ? 'tag-container-active' : 'tag-container'"
      :style="tagContainerHeight === true ? 'max-height:fit-content' : ''"
      id="panel">
      <v-chip
        :density="dense ? 'compact' : 'default'"
        class="mr-2 custom-chip"
        style="user-select: none"
        size="large"
        @click="
          toggleTagFilter(tag.uid);
          emit('select', tag);
        "
        :color="filterByTag.includes(tag.uid) ? 'primary' : ''"
        :class="filterByTag.includes(tag.uid) ? 'active-custom-tag' : ''"
        v-for="tag in tags">
        {{ tag.name }}
        <div
          class="ml-2"
          v-if="tag.usage"
          style="opacity: 0.5">
          ({{ tag.usage }})
        </div>
      </v-chip>
      <!-- Quick Add Tag Button -->
      <v-chip
        v-if="editMode && showAddButton"
        :density="dense ? 'compact' : 'default'"
        class="mr-2 custom-chip add-tag-chip"
        size="large"
        @click="addTagDialog = true"
        title="Quick add new tag">
        <v-icon size="small">mdi-plus</v-icon>
      </v-chip>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import { deluge } from '@/stores/deluge.js';
import { onMounted } from 'vue';
import AddTag from '../Configure/add_tag.vue';

// Quick add tag dialog state
const addTagDialog = ref(false);

const toggled = ref(true);
const filteredTags = computed(() => {
  if (props.showTags) {
    return Object.values(props.tags).filter(props.showTags);
  } else {
    return props.tags;
  }
});
const props = defineProps({
  tagContainerHeight: {
    type: Boolean,
    default: () => false,
  },
  selectable: {
    type: Boolean,
    default: () => true,
  },
  tags: {
    type: Object,
    default: () => [],
  },
  filterByTag: {
    type: Array,
    default: () => [],
  },
  editMode: {
    type: Boolean,
    default: () => false,
  },
  dense: {
    type: Boolean,
    default: () => false,
  },
  showTags: {
    type: Function,
  },
  showAddButton: {
    type: Boolean,
    default: () => false,
  },
});
onMounted(() => {
  if (props.editMode) {
    toggled.value = false;
  }
});
const emit = defineEmits(['select', 'newTag']);

// Handler for when a new tag is created via quick add
function onNewTagAdded(newTagObj) {
  // Emit the new tag so parent can handle it (e.g., auto-select)
  emit('newTag', newTagObj);
}

// function find_all_tags(){
//   let allTags = {};
// }

function find_all_categories() {
  let items = {};
  for (const tag of Object.values(deluge.tags)) {
    if (!items[tag.category]) {
      items[tag.category] = [];
    }
    items[tag.category].push(tag);
  }
  return items;
}

const tagtitle = ref([]);

function toggleTagFilter(tagUid) {
  if (props.editMode) {
    return;
  }
  console.log(props.editMode);
  if (props.filterByTag.includes(tagUid)) {
    props.filterByTag.splice(props.filterByTag.indexOf(tagUid), 1);
  } else {
    props.filterByTag.push(tagUid);
  }
  // filterScenes();
}
</script>
<style scoped>
.tag-main-bar {
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
}
.tag-container {
  opacity: 1;
  transition: 0.2s;
  max-height: 166px;
  overflow: auto;
  position: relative;
}
.tag-container-active {
  /* opacity: 0; */
  opacity: 0;
  max-height: 0px;
}

.tag-hide-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  /* position: absolute;
  right: 0px;
  bottom: 8px; */
  transition: 0.2s;
}

.tag-hide-icon-active {
  transform: rotate(180deg);
}

.tag-expand-button {
  position: relative;
  border-radius: 5px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-bottom: 7px;
  transition: 0.2s;
  cursor: pointer;
  border-color: var(--inner-background);
  height: 40px;
  width: 40px;
  background-color: var(--v-cardColor-base);
  display: flex;
  justify-content: center;
  align-items: center;
}

.tag-expand-button:hover {
  background: var(--primary-color-hover);
  /* outline: px solid var(--inner-background); */
  /* border: 10px solid var(--inner-background); */
  border-bottom: 0px;
  border-top: 0px;
  transition: 0.2s;
}

.tag-expand-button-active {
  background: var(--v-primary-base);
  color: white;
}

.tag-expand-button-active:hover {
  background: var(--v-primary-base);
}

.custom-chip {
  margin-top: 3px;
  margin-bottom: 3px;
}

.add-tag-chip {
  opacity: 0.5;
  cursor: pointer;
  user-select: none;
  min-width: 70px;
  justify-content: center;
  transition: opacity 0.2s ease;
}

.add-tag-chip:hover {
  opacity: 1;
}

.active-custom-tag {
  background-color: #5d6ae3;
  color: white !important;
}

.tag-carousel-replacement {
  width: 100%;
  /* border-bottom: 2px solid #f5fafb; */
  margin-bottom: 10px;
  margin-right: 25px;
}

/* animations */

.fadeInRight {
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
</style>
